// Zahlungsempfaenger fuer die Banküberweisung.
// Einzige Quelle fuer Checkout-Bestaetigung und E-Mail-Vorlage — bei einer
// Aenderung hier muss auch das EmailJS-Template angepasst werden
// (Documentation/emailjs-bestellbestaetigung.html).

export const BANK_DETAILS = {
  iban: "CH11 8080 8007 9827 9358 0",
  holder: "Robin Bühler",
  street: "Luzernerstrasse 48",
  city: "6330 Cham",
};

export const TWINT_PAYMENT_URL =
  "https://go.twint.ch/1/e/tw?tw=acq.qnNCaQ53T8qsqFEfPp0bFloy8WPdOrl3DA02V-Mu5BR0loQz9VBc9gNCIa0XORNi.";
